import React from 'react'
import { storage } from '../firebase';
import { Link } from 'react-router-dom';
import update from 'immutability-helper';
import { Modal, ModalBody, CardBody, Col, Card, Button, UncontrolledAlert } from 'reactstrap';
import Auth from '../config/Auth';
import ModalLista from './ModalLista';
import Lista from '../pages/Lista';

class Evento extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isOpen: false,
      index: props.index !== null ? props.index : 0,
      festa: props.festa !== null ? props.festa : null,
      id: props.id !== null ? props.id : '', 
    }

    this.toggle = this.toggle.bind(this);
    this.loadImage = this.loadImage.bind(this);
  }

  componentDidMount() {
    this.loadImage('img-' + this.state.index);
  }

  toggle() {
    const isOpen = !this.state.isOpen;

    this.setState(state => update(state, {
      isOpen: { $set: isOpen }
    }), () => {
      if (isOpen === true) {
        this.loadImage('full-' + this.state.index);
      }
    })
  }

  loadImage(id) {
    if (this.state.festa.info.flyer !== undefined) {
      const path = this.state.festa.info.flyer;

      if (path.includes('http') || path.includes('https')) {
        setTimeout(function () {
          document.getElementById(id).innerHTML = "<img src='" + path + "' className='card-img-top' style='max-width:100%;' />";
        }, 500);
      }
      else {
        storage.child(this.state.festa.info.flyer).getDownloadURL().then(
          (url) => {
            document.getElementById(id).innerHTML = "<img src='" + url + "' className='card-img-top' style='max-width:100%;' />";
          },
          (error) => {
            console.log(error)
          });
        }
    }
  }

  listaDisponivel(festaTimestamp, listaAte) {
    const currentTimestamp = parseInt(Date.now() / 1000);
    const listaLimite = parseInt(festaTimestamp + ((listaAte !== undefined ? listaAte : 2) * 60 * 60) / 1000);

    //this.getHorasRestantes(currentTimestamp <= listaLimite ? listaLimite - currentTimestamp : 0)

    return (currentTimestamp <= listaLimite)
  }

  render() {
    const item = this.state.festa;
    const i = this.state.index;

    const nome = (item.info.nome !== undefined && item.info.nome !== '') ? item.selo.info.nome + ' - ' + item.info.nome : item.selo.info.nome;
    const key = item.key
    const lista = item.lista.disponivel !== undefined ? item.lista.disponivel : null;

    const online = item.info.urlFestaOnline;
    var festaOnline = false;
    var localString = "";
    if (item.info.urlFestaOnline !== undefined && item.info.urlFestaOnline !== "") {
      festaOnline = true
      localString = "Online";
    } 

    const local = item.local;
    var enderecoString = "";
    if (local !== undefined) {
      enderecoString += local.endereco.logradouro;
      enderecoString += "\n";
      localString = item.local.info.nome;
      if (local.endereco.cidade !== undefined && local.endereco.uf !== undefined) enderecoString += local.endereco.cidade + " / " + local.endereco.uf;
      if (local.endereco.cep !== undefined) enderecoString += "\nCEP: " + local.endereco.cep;
      if (local.info.telefone !== undefined) enderecoString += "\n\nTelefone: " + local.info.telefone;
      if (local.info.servico !== undefined && local.info.servico !== "") enderecoString += "\n\n" + local.info.servico;
    }

    var urlIngresso = "";
    if (item.info.ingressoAntecipado !== undefined) {
      urlIngresso = item.info.ingressoAntecipado;
    }

    const dataHora = new Date(item.info.dataHora);
    var dataHoraString = "";
    if (dataHora !== undefined) {
      dataHoraString = dataHora.toLocaleDateString().substr(0, 5)  + ' às ' + dataHora.toLocaleTimeString().substr(0, 5) + " - " + localString
    }

    var listaDisponivel = false;
    if (item.lista != undefined && item.lista.disponivel === true) {
      listaDisponivel = this.listaDisponivel(item.info.dataTimestamp, item.lista.info.disponivelHorasAntes);
    }

    return <React.Fragment>
      <Modal isOpen={this.state.isOpen} toggle={this.toggle} >
        <div id={"full-" + i} /> 
        <spam className="h5 m-3" style={{ position: 'absolute', top: 0, left: 0, opacity: 0.8 }}><Button color="light" onClick={this.toggle}><strong>&times;</strong></Button></spam> 
        <ModalBody>
          <Card className="mb-3">
            <CardBody>
              <p className="h5">{nome}</p>
              <p className="text-secondary"> { dataHoraString }</p>
              <p className="text-secondary"> {
                  item.info.sobre.split("\n").map(function (text, idx) {
                    return (
                      <span key={idx}>
                        {text}
                        <br />
                      </span>
                    )
                  })
                }
                </p> {
                  lista ? 
                    Auth.isAuthenticated ?
                      <span className="float-right"><Link to={'/listas/' + key} target='_blank'><Button color="primary" className="mr-1" >Lista</Button></Link><Link to={'/lista/' + key} className="m-1" target='_blank'><Button color="secondary">Formulário lista</Button></Link></span>
                    :
                      listaDisponivel ?
                        <span className="float-right"><ModalLista className="float-right" id={key} title={nome} /> </span>
                      :
                        <UncontrolledAlert color="warning" className="text-center mt-1">Lista encerrada.</UncontrolledAlert>
                  :
                    null
                } {
                  festaOnline ? 
                  <span className="float-right"><Button color="primary" className="mr-1" onClick={() => { window.open(online, "_blank") }}>Festa online</Button></span>
                  :
                    null
                } {
                  urlIngresso !== "" ?
                  <span className="float-right"><Button color="primary" className="mr-1"  onClick={() => { window.open(urlIngresso, "_blank") }}>Ingresso Antecipado</Button></span>
                  :
                  null
                } 
            </CardBody>
          </Card> {
            local !== undefined ?
            <Card>
                <img alt="flyer" src={'https://www.mapquestapi.com/staticmap/v5/map?key=tJzWoYI61a20gNlne5712qCivYiII3Gc&center=' + local.endereco.logradouro + " " + local.endereco.cidade + " " + local.endereco.uf + "&size=500,300&zoom=16&type=" + "light"} />
                <CardBody>
                  <p className="h5">{local.info.nome}</p>
                  <p className="text-secondary"> {
                    enderecoString.split("\n").map(function (text, idx) {
                      return (
                        <span key={idx}>
                          { text }
                          <br />
                        </span>
                      )
                    })
                  }</p>
                  <span className="float-right"><Button color="primary" onClick={() => { window.open("https://www.google.com/maps/search/?api=1&query=" + local.endereco.logradouro + " " + local.endereco.cidade + " " + local.endereco.uf, "_blank")}}>Direções</Button></span>
                </CardBody>
            </Card> 
            :
            null
          }
        </ModalBody>
      </Modal>
      <Col xs={12} sm={6} md={4} lg={3} className="pl-0 pr-0 ml-0 mr-0">
        <Card key={i} className="m-1" style={{ cursor: 'pointer' }} onClick={this.toggle}>
          <div id={"img-" + i} /> 
        </Card>
      </Col>
    </React.Fragment>
  }
}

export default Evento